/**
 *
 * Retourne le détail du nombre de sac pour une commande
 * @param {Object} order
 * @return {Object}
 *  orderBagsDetail: Nombre de sac sans opz: sec, iso
 *  bagDetail: Nombre de sac opz compris: total, sec, iso
 *  extraPlaces: Pseudozones avec nombre de sac (utilisé dans le formulaire)
 *  getFormattedContent: Contenu à afficher (différent flow vs. support)
 *
 */
export const useNumberOfBags = (order) => {
  const {
    number_of_bags_isotherm,
    number_of_bags,
    pseudo_zones_status,
  } = order;

  const orderNbOfBagsIsotherm = number_of_bags_isotherm || 0;

  const orderNbOfBagsDry =
    number_of_bags - number_of_bags_isotherm;

  let bagIsoCount = orderNbOfBagsIsotherm;
  let bagDryCount = orderNbOfBagsDry;
  let extraPlaces = [];

  if (pseudo_zones_status && pseudo_zones_status.length) {
    let [isoBagsOpz] = pseudo_zones_status.reduce(
      ([isoCount], opz) => {
        if (
          opz.pseudozone &&
          opz.pseudozone.is_active &&
          (opz.is_bag_picking_late || opz.pseudozone.bag_apart)
        ) {
          isoCount +=
            opz.nob_iso && opz.pseudozone.bag_picking_late_label === "FRAIS"
              ? opz.nob_iso
              : 0;
          extraPlaces = [
            ...extraPlaces,
            {
              id: opz.id,
              pseudoZone: opz.pseudozone,
              number_of_bags_iso: opz.nob_iso ? opz.nob_iso : 0,
              field_name: "pz_number_of_bag_iso_" + opz.pseudozone_id,
            },
          ];
        }
        return [isoCount];
      },
      [0, 0]
    );

    bagIsoCount += isoBagsOpz;
  }

  const totalBagsCount = bagDryCount + bagIsoCount;

  const getFormattedContent = (showFullInfo = false) => {
    if (showFullInfo) {
      return `${totalBagsCount} sacs = ${bagDryCount}sec + ${bagIsoCount}frais`;
    }
    return `${bagDryCount}+${bagIsoCount}`;
  };

  return {
    orderBagsDetail: [
      orderNbOfBagsDry,
      orderNbOfBagsIsotherm
    ],
    bagsDetail: [totalBagsCount, bagDryCount, bagIsoCount],
    extraPlaces,
    getFormattedContent,
  };
};
